import React,{Component} from 'react';

import {Row, Col, Clearfix, Button} from 'react-bootstrap';

import FormOverlay from '../../../../components/FormOverlay';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import Icon from '../../../../components/Icon';

const mobileValues = {
    1: 'Mobile',
    0: 'PC',
    '': 'All'
};

class Form extends Component {
    constructor(props) {
        super(props);

        if(props.segment) {
            this.state = this.getSegmentData(props.segment);
        }
        else {
            this.state = {
                name: '',
                countries: [],
                firstSessionGt: '',
                firstSessionLt: '',
                tag: '',
                tag1: '',
                tag2: '',
                tag3: '',
                tag4: '',
                tag5: '',
                mobile: ''
            }
        }


        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    getSegmentData(segment) {
        const params = ['name', 'countries', 'firstSessionGt', 'firstSessionLt', 'tag', 'tag1', 'tag2', 'tag3', 'tag4', 'tag5', 'mobile'];

        return params.reduce((obj, param) => {
            const value = segment[param];

            if(value || value === 0) {
                obj[param] = value;
            }
            else {
                obj[param] = '';
            }

            return obj;
        }, {});
    }

    handleFieldChange(event) {
        const {target} = event;
        const {value,name} = target;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.state);
    }

    render() {
        return (
            <FormOverlay onFormHide={this.props.onFormHide}>
                <form onSubmit={this.handleSubmit}>
                    <FieldGroup
                        name="name"
                        label="Name:"
                        onChange={this.handleFieldChange}
                        value={this.state.name}
                        required
                    />
                    <SelectWrap
                        value={this.state.countries}
                        name="countries"
                        label="Countries:"
                        values={this.props.countries}
                        onChange={this.handleFieldChange}
                        multi={true}
                    />
                    <Row>
                        <Col lg={6}>
                            <FieldGroup
                                name="firstSessionGt"
                                label="First session GT:"
                                onChange={this.handleFieldChange}
                                value={this.state.firstSessionGt}
                            />
                        </Col>
                        <Col lg={6}>
                            <FieldGroup
                                name="firstSessionLt"
                                label="First session LT:"
                                onChange={this.handleFieldChange}
                                value={this.state.firstSessionLt}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={2}>
                            <FieldGroup
                                name="tag"
                                label="Tag:"
                                onChange={this.handleFieldChange}
                                value={this.state.tag}
                            />
                        </Col>
                        <Col lg={2}>
                            <FieldGroup
                                name="tag1"
                                label="Tag1:"
                                onChange={this.handleFieldChange}
                                value={this.state.tag1}
                            />
                        </Col>
                        <Col lg={2}>
                            <FieldGroup
                                name="tag2"
                                label="Tag2:"
                                onChange={this.handleFieldChange}
                                value={this.state.tag2}
                            />
                        </Col>
                        <Col lg={2}>
                            <FieldGroup
                                name="tag3"
                                label="Tag3:"
                                onChange={this.handleFieldChange}
                                value={this.state.tag3}
                            />
                        </Col>
                        <Col lg={2}>
                            <FieldGroup
                                name="tag4"
                                label="Tag4:"
                                onChange={this.handleFieldChange}
                                value={this.state.tag4}
                            />
                        </Col>
                        <Col lg={2}>
                            <FieldGroup
                                name="tag5"
                                label="Tag5:"
                                onChange={this.handleFieldChange}
                                value={this.state.tag5}
                            />
                        </Col>
                        <Col lg={12}>
                            <SelectWrap
                                value={this.state.mobile}
                                name="mobile"
                                label="Device type:"
                                values={mobileValues}
                                onChange={this.handleFieldChange}
                            />
                        </Col>

                    </Row>
                    <Clearfix>
                        <Button className="pull-right" bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                    </Clearfix>
                </form>
            </FormOverlay>
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/scenes/Segments/components/Form/index.js